/**
 * @module builder
 */
import type { QuoteDocument, AreaSubstrate, OptionsDocument } from 'paintscout'
import type { UpdateableAreaSubstrate } from '../index'

import findIndex from 'lodash/findIndex'
import { toUpdateableAreaSubstrate } from './util'

type GetAreaSubstrateArgs = {
  quote?: QuoteDocument
  options: OptionsDocument
  areaKey?: string
  key?: string
  full?: boolean
}

// Return the 'full' AreaSubstrate, right from quote,
// or translate to updateableAreaSubstrate, if exists
export function getAreaSubstrate<T extends boolean>(
  args: GetAreaSubstrateArgs & { full?: T }
): T extends true ? AreaSubstrate : UpdateableAreaSubstrate {
  const { quote, areaKey, key, full, options } = args
  let r: UpdateableAreaSubstrate | AreaSubstrate

  Object.keys(quote.areas[areaKey].substrates).forEach((section) => {
    const index = findIndex(quote.areas[areaKey].substrates[section], { key })

    if (index !== -1) {
      const areaSubstrate = quote.areas[areaKey].substrates[section][index]
      if (areaSubstrate) {
        r = full
          ? (areaSubstrate as AreaSubstrate)
          : (toUpdateableAreaSubstrate({
              areaSubstrate,
              options,
              areaKey,
              substrateKey: key,
              quote
            }) as UpdateableAreaSubstrate)
      }
      // return either full areaSubstrate, or convert to UpdateableAreaSubstrate
    }
  })

  return r as T extends true ? AreaSubstrate : UpdateableAreaSubstrate
}
